// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"a888b3b5974d578abbd3","339":"453aff4f9dae04ea1054"}[chunkId] + ".js";
};